import { useAppStore } from "./app";
import { useMenuStore } from "./menu";
import { useProcessStore } from "./process";
import { useUserStore } from "./user";
import { useShopStore } from "./shop";
import { useTakephotoStore } from "./takephoto";
import { useWatermaskStore } from "./watermask";
import { useLangStore } from "./lang";
import { useTimezoneStore } from "./timezone";
import { useTakeStore } from "./take";
import { useOemStore } from "./oem";
import { useShakeCheckStore } from "./shakeCheck";
import { useDepartmentStore } from "./department";
import { useProductStore } from "./product";

export function useBaseStore() {
	const app = useAppStore();
	const menu = useMenuStore();
	const process = useProcessStore();
	const user = useUserStore();
	const takephoto = useTakephotoStore();
	const shop = useShopStore();
	const watermask = useWatermaskStore();
	const lang = useLangStore();
	const timezone = useTimezoneStore();
	const takeData = useTakeStore();
	const oem = useOemStore();
	const shakeCheck = useShakeCheckStore();
	const department = useDepartmentStore();
	const product = useProductStore();
	return {
		app,
		menu,
		process,
		takephoto,
		shop,
		user,
		watermask,
		lang,
		timezone,
		takeData,
		oem,
		shakeCheck,
		department,
		product
	};
}

const useStore = useBaseStore;

export { useStore };
